const taskTypeTransformHelper = response => {
  const targetTypes = {
    per_day: "Per Day",
    total: "Total",
  }

  const generateTargetTypesList = configObj => {
    let targetTypesList = Object.keys(configObj).map((targetTypeKey, i) => {
      return { id: targetTypeKey, title: targetTypes[targetTypeKey] }
    })
    return targetTypesList
  }

  return response?.map(e => (e.config ? { ...e, targetTypes: generateTargetTypesList(e.config) } : e)) || []
}

export default taskTypeTransformHelper
